<template>
    <div class="container-fluid form-container fire-alarm-test-form-container">
        <div class="row">
            <div class="col-sm-12">
                <h1 class="page-title">
                    Fire Alarm Certificate
                </h1>
            </div>
        </div>
        <form
            action=""
            class="fire-alarm-certificate"
            @submit.prevent="saveForm()"
        >
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12 col-md-6 form-group">
                            <label for="customer">Customer</label>
                            <customer-search
                                ref="customerSearch"
                                :customer="form.customer"
                                @change="customerChanged"
                                :customer-id="form.customer_id"
                            />
                            <error
                                name="customer_id"
                                :errors="errors"
                            />
                        </div>
                        <div
                            class="col-sm-12 col-md-6 form-group"
                            v-if="form.customer && form.customer.sites"
                        >
                            <label for="site">Site:</label>
                            <select
                                name="site"
                                v-model="form.site_id"
                                id="site"
                                class="form-control"
                                placeholder="Site"
                                required
                                v-if="form.customer.sites.length"
                                @change="siteChanged()"
                            >
                                <option
                                    v-for="site in form.customer.sites"
                                    :key="site.id"
                                    :value="site.id"
                                >
                                    #{{ site.site_no }} {{ site.name }}
                                </option>
                            </select>
                            <span
                                class="form-error"
                                v-if="!form.customer.sites.length"
                            >This customer has no sites</span>
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-3 form-group">
                            <label for="po_number">Purchase Order No.</label>
                            <input
                                type="text"
                                id="po_number"
                                name="po_number"
                                v-model="form.po_number"
                                placeholder="Purchase Order No."
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="po_number"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="fire_alarm_type">Fire Alarm System Type</label>
                            <select
                                name="fire_alarm_type"
                                id="fire_alarm_type"
                                v-model="form.fire_alarm_type"
                                class="form-control"
                            >
                                <option disabled>
                                    Select
                                </option>
                                <option value="L1">
                                    L1
                                </option>
                                <option value="L2">
                                    L2
                                </option>
                                <option value="L3">
                                    L3
                                </option>
                                <option value="L4">
                                    L4
                                </option>
                                <option value="L5">
                                    L5
                                </option>
                                <option value="P1">
                                    P1
                                </option>
                                <option value="P2">
                                    P2
                                </option>
                                <option value="M">
                                    M
                                </option>
                                <option value="(M) Warehouse & Office L1">
                                    (M) Warehouse & Office L1
                                </option>
                                <option value="(M) Warehouse & Office L4">
                                    (M) Warehouse & Office L4
                                </option>
                                <option value="X">
                                    X
                                </option>
                            </select>
                            <error
                                name="fire_alarm_type"
                                :errors="errors"
                            />
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <label for="service_type">What service are you carrying out?</label>
                            <select
                                name="service_type"
                                id="service_type"
                                v-model="form.service_type"
                                class="form-control"
                            >
                                <option disabled>
                                    Select
                                </option>
                                <option>Full New Service - System Take Over</option>
                                <option>6 Monthly Routine Inspection</option>
                                <option>3 Monthly Routine Inspection</option>
                                <option>Non-routine Service</option>
                            </select>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p>
                                I/We being the competent person(s) responsible (as indicated by my/our signature below) for the servicing of the fire
                                alarm system, particulars of which are set out below, CERTIFY the said work for which I/we have been responsible complies
                                to the best of my/our knowledge and belief with the recommendations of BS 5839-1:2025, Clause 43 quarterly
                                inspection of vented batteries/periodic inspection and test/inspection and test over a 12 month period (delete as applicable) except for variations, if any, as stated in this certificate.
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-8">
                            <label class="top">Engineer Signature:</label>
                            <br>
                            <user-select
                                v-model="form.engineer_id"
                                :office="false"
                                :admins="false"
                            />
                        </div>

                        <div class="col-sm-4">
                            <label for="engineer_position">Position:</label>
                            <input
                                type="text"
                                v-model="form.engineer_position"
                                id="engineer_position"
                                name="engineer_position"
                                placeholder="Position"
                                class="form-control"
                            >
                            <error
                                :errors="errors"
                                name="engineer_position"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p>
                                <strong>For and on behalf of:</strong> {{ sysSetting('company_name') }}
                            </p>
                            <p>
                                <strong>Address:</strong> {{ sysSetting('address') }}
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <label>Date of last service:</label>
                            <date-picker
                                v-model="form.date_last_service"
                                :options="{format: 'L'}"
                                placeholder="DD/MM/YYYY"
                            />
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <label for="test_date">Test Date:</label>
                            <br>
                            <date-picker
                                v-model="form.test_date"
                                id="test_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="test_date"
                            />
                        </div>

                        <div class="col-sm-12 col-md-4">
                            <label for="expire_date">Expire Date End Of:</label>
                            <br>
                            <date-picker
                                v-model="form.expire_date"
                                id="expire_date"
                                :options="{format: 'L'}"
                                required
                            />
                            <error
                                :errors="errors"
                                name="expire_date"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="doc_no">Docket No:</label>
                            <input
                                type="text"
                                v-model="form.doc_no"
                                placeholder="Docket No."
                                class="form-control"
                            >
                            <error
                                name="doc_no"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <label>Site ID No:</label>
                            <input
                                type="text"
                                v-model="form.site_id"
                                placeholder="Site ID No."
                                readonly
                                class="form-control"
                            >
                            <error
                                name="site_id"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="percent_checked">Percentage of System Checked:</label>
                            <div class="input-group">
                                <input
                                    type="text"
                                    v-model="form.percentage_checked"
                                    placeholder="100"
                                    class="form-control text-right"
                                >
                                <div class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>
                            </div>
                            <error
                                name="percentage_checked"
                                :errors="errors"
                            />
                        </div>

                        <div class="col-sm-12 col-md-6">
                            <label for="check_period">System Periodically Checked:</label>
                            <p>
                                Every
                                <input
                                    type="text"
                                    v-model="form.check_period"
                                    placeholder="12"
                                    size="3"
                                    class="form-control inline-control"
                                >
                                months
                            </p>
                            <error
                                name="check_period"
                                :errors="errors"
                            />
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label for="type_of_signalling">Type of Signalling to Fire & Rescue Service?</label>
                            <select
                                v-model="form.type_of_signalling"
                                class="form-control"
                                required
                            >
                                <option :value="null">
                                    Select
                                </option>
                                <option>Bells Only</option>
                                <option>Arc - Keyholder</option>
                                <option>Arc - Fire Brigade</option>
                            </select>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <label for="bafe_cert_no">Does the system have a BAFE Certificate of Compliance Number?</label>
                            <input
                                type="text"
                                v-model="form.bafe_cert_no"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p>The extent of liability of the signatory is limited to the system described below - Extent of system covered by this certificate:</p>
                            <textarea
                                name="extent"
                                id="extent"
                                rows="3"
                                v-model="form.extent"
                                class="form-control"
                            />
                            <error
                                name="extent"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p>Variations from the recommendations of BS 5839-1:2025 clause 43 for a periodic or annual inspection and test (as applicable):</p>
                            <textarea
                                name="extent"
                                id="variations"
                                rows="3"
                                v-model="form.variations"
                                class="form-control"
                            />
                            <error
                                name="variations"
                                :errors="errors"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-check">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="entered_in_log_book"
                                    v-model="form.entered_in_log_book"
                                >
                                <label for="entered_in_log_book">
                                    Relevant details of all the work carried out & faults identified have been entered in the system log book:
                                </label>
                            </div>
                        </div>

                        <div class="col-sm-12">
                            <p>
                                During the past 12 months, <input
                                    type="text"
                                    class="form-control inline-control"
                                    size="3"
                                    v-model="form.false_alarms"
                                > false alarms have occurred / (For category M systems enter "Not Applicable").
                            </p>
                            <p>
                                The above number of false alarms equates to <input
                                    type="text"
                                    size="3"
                                    class="form-control inline-control"
                                    v-model="form.false_alarms_percent"
                                > false alarms per 100 automatic fire detectors per annum.
                            </p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <p>The following work/action is considered necessary:</p>
                            <textarea
                                name="extent"
                                id="work_necessary"
                                rows="3"
                                v-model="form.work_necessary"
                                class="form-control"
                            />
                            <error
                                name="work_necessary"
                                :errors="errors"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-body">
                    <div class="row form-group">
                        <div class="col-12">
                            <button
                                class="btn btn-success"
                                type="submit"
                                :disabled="isLoading || isSaving"
                            >
                                Save
                            </button>

                            <button
                                class="btn btn-outline-danger"
                                type="button"
                                @click="deleteForm()"
                                :disabled="isLoading || isSaving"
                                v-if="form.id && canDelete"
                            >
                                <i class="fa fa-times" /> Delete
                            </button>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/stream'"
                                target="_blank"
                            >
                                <i class="fa fa-print" /> Preview/Print
                            </a>

                            <a
                                class="btn btn-info"
                                v-if="form.id"
                                :href="'/api/forms/' + form.id + '/download'"
                                target="_blank"
                                :download="form.doc_no + '.pdf'"
                            >
                                <i class="fa fa-file" /> Download PDF
                            </a>

                            <router-link
                                class="btn btn-info"
                                v-if="form.id && form.customer_id"
                                :to="{name: 'office.emails.new', params: {customer_id: form.customer_id}, query: {form_id: form.id}}"
                            >
                                <i class="fa fa-envelope" /> Send to Customer
                            </router-link>

                            <customer-site-footer-links
                                :customer-id="form.customer_id"
                                :site-id="form.site_id"
                            />

                            <activity-log
                                v-if="form.id"
                                :id="form.id"
                                model="Form"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import datePicker from "../DateTimePickerComponent.vue";
import CustomerSearchComponent from "../CustomerSearch.vue";
import FormService from "../../services/FormService";
import * as moment from "moment";
import AuthService from "../../services/AuthService";
import SignatureService from "../../services/SignatureService";
import UsesErrors from "../../mixins/UsesErrors";
import SettingsMixin from "../../mixins/SystemSettings";
import UsesInfoMessage from "../../mixins/UsesInfoMessage";
import UsesFormRouteQuery from "../../mixins/UsesFormRouteQuery";

export default {
    components: {
        "customer-search": CustomerSearchComponent,
        "date-picker": datePicker,
    },
    mixins: [
        UsesErrors,
        UsesInfoMessage,
        SettingsMixin,
        UsesFormRouteQuery,
    ],
    data: function () {
        return {
            form: {
                type: 'fire_alarm_certificate',
                customer: null,
                engineer_position: 'Engineer',
            },
            token: null,
            sites: [],
        }
    },
    computed: {
        canDelete: function () {
            return AuthService.user.admin_access || AuthService.user.office_access;
        },
    },

    mounted: function () {
        this.populateFormFromRouteQuery();

        if (this.$route.params.id) {
            const id = this.$route.params.id;
            this.loadForm(id);
        } else {
            FormService.nextNo().then(res => {
                this.form.doc_no = res.data;
            });
        }


        if (!this.form.engineer_sign_date) {
            this.form.engineer_sign_date = moment();
        }

        if (typeof this.$route.query.alarm_form !== 'undefined') {
            this.loadAlarmForm(this.$route.query.alarm_form);
        }

        if (!this.form.engineer_sign_date) {
            this.form.engineer_sign_date = moment();
        }
        if (!this.form.date_last_service) {
            this.form.date_last_service = moment();
        }
        if (!this.form.test_date) {
            this.form.test_date = moment();
        }
        if (!this.form.expire_date) {
            this.form.expire_date = moment().add(6, 'months');
        }

        if(!this.form.engineer_sign_name && AuthService.user.engineer_access) {
            this.form.engineer_sign_name = AuthService.user.name;
            this.engineerNameChanged();
        }
    },

    methods: {
        loadForm: function (id) {
            this.setLoading();
            FormService.get(id).then(res => {
                this.form = res.data;

                if (!this.form.customer) {
                    this.form.customer = {
                        company_name: '',
                    };
                }

                if (res.data.engineer_sign_date) {
                    this.form.engineer_sign_date = moment(res.data.engineer_sign_date);
                } else {
                    this.form.engineer_sign_date = moment();
                }
                if (res.data.test_date) {
                    this.form.test_date = moment(res.data.test_date);
                } else {
                    this.form.test_date = moment();
                }
                if (res.data.date_last_service) {
                    this.form.date_last_service = moment(res.data.date_last_service);
                } else {
                    this.form.date_last_service = moment();
                }
                if (res.data.expire_date) {
                    this.form.expire_date = moment(res.data.expire_date);
                } else {
                    this.form.expire_date = moment().add(6, 'months');
                }

            }, () => {
                this.setErrorMessage('Could not load form');
            }).then(() => {
                this.clearLoading();
            });
        },

        customerChanged: function (customer) {
            this.form.customer = customer ? customer : {};
            if (this.form.customer) {
                this.form.customer_id = this.form.customer.id;
            } else {
                this.form.customer_id = null;
            }
            if (customer && customer.sites) {
                if (!customer.sites.map(site => site.id).includes(this.form.site_id)) {
                    this.form.site_id = '';
                    this.siteChanged();
                }
            } else {
                this.form.site_id = '';
                this.siteChanged();
            }
        },

        siteChanged: function () {

        },

        saveForm: function () {
            this.setSaving();
            let data = {...this.form};
            delete data['customer'];
            delete data['site'];
            delete data['job'];
            delete data['data'];

            if (this.form.id) {
                FormService.update(data).then(
                    res => {
                        this.clearSaving();
                        this.setInfoMessage("Form saved successfully");
                        this.$emit('formSaved', res.data);
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            } else {
                FormService.create(data).then(
                    res => {
                        this.setInfoMessage("Form saved successfully");
                        this.clearSaving();
                        if (this.$route.path.includes('engineer/')) {
                            this.$router.push({
                                name: "engineer.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        } else {
                            this.$router.push({
                                name: "office.forms.edit",
                                params: {
                                    id: res.data.id
                                }
                            });
                        }
                    },
                    err => {
                        this.clearSaving();
                        this.captureRequestErrors(err);
                    }
                );
            }
        },

        deleteForm: function () {
            if (confirm("Are you sure you want to delete this form?")) {
                FormService.delete(this.form).then(
                    () => {
                        this.setInfoMessage("Form successfully deleted");
                        this.$router.push({name: 'office.forms.search'});
                    },
                    () => {
                        this.setErrorMessage("Could not delete this form");
                    }
                )
            }
        },

        engineerNameChanged: function () {
            this.form.engineer_signature_text = SignatureService.nameToSignature(this.form.engineer_sign_name);
        },
            
        loadAlarmForm: function (form_id) {
            this.setLoading();
            this.form.alarm_form_id = form_id;
            FormService.get(form_id).then(xhr => {
                const testForm = xhr.data;
                this.form.customer = testForm.customer;
                this.form.customer_id = testForm.customer_id;
                this.form.site_id = testForm.site_id;
                this.form.fire_alarm_type = testForm.fire_alarm_type;
                this.form.service_type = testForm.service_type;
                if (testForm.engineer_sign_date) {
                    this.form.engineer_sign_date = moment(testForm.engineer_sign_date);
                    this.form.test_date = moment(testForm.engineer_sign_date);
                    this.form.expire_date = moment(testForm.engineer_sign_date).add(6, 'months');
                }
                this.form.engineer_signature_text = testForm.engineer_signature_text;
                this.form.engineer_sign_name = testForm.engineer_sign_name;
                this.form.engineer_id = testForm.engineer_id;
                this.form.percentage_checked = testForm.percentage_checked;
                this.form.work_necessary = testForm.recommendations;
                this.form.type_of_signalling = testForm.type_of_signalling;
                this.form.bafe_cert_no = testForm.bafe_cert_no;
                if (testForm.date_last_service) {
                    this.form.date_last_service = moment(testForm.date_last_service);
                }
            }, () => {
                this.setErrorMessage('Could not load original form');
            }).then(() => {
                this.clearLoading();
            });
        }
    }
}
</script>

<style lang="scss" scoped="true">
    .row {
        margin-bottom: 1.5rem;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/FireAlarmCertificateComponent.vue